import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IdiomaService } from "../../services/idioma.service";
import { TraducaoService } from "../../services/traducao.service";
import { BotaoHomeComponent } from "./botao-home/botao-home.component";
import { BotaoTopoComponent } from "./botao-topo/botao-topo.component";
import { Subscription } from "rxjs";


@Component({
  selector: 'app-container-botao',
  standalone: true,
  imports: [ BotaoHomeComponent, BotaoTopoComponent ],
  templateUrl: './container-botao.component.html',
  styleUrl: './container-botao.component.css'
})
export class ContainerBotaoComponent implements OnInit, OnDestroy {
  topo: string = '';
  home: string = '';

  private subscriptions: Subscription[] = [];

  @Output() voltarHome: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrollToTop: EventEmitter<void> = new EventEmitter<void>();
  @Input() isScrollAtTop: boolean = true;

  constructor(
    private traducaoService: TraducaoService,
    private idiomaService: IdiomaService,
    private router: Router
    ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.idiomaService.idioma$.subscribe(idioma => {
        this.subscriptions.push(
          this.traducaoService.obterTraducao('topo').subscribe({
            next: traducao => this.topo = traducao,
            error: err => console.error('Erro ao obter tradução para Topo:', err)
          })
        );
        this.subscriptions.push(
          this.traducaoService.obterTraducao('home').subscribe({
            next: traducao => this.home = traducao,
            error: err => console.error('Erro ao obter tradução para Home:', err)
          })
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onScrollToTop(): void {
    console.log('scrollToTop');
    this.scrollToTop.emit();
  }

  onVoltarHome(): void {
    console.log('voltarHome');
    this.voltarHome.emit();
  }
}
